import { helpers }  from '../../helpers/helpers.js';

var tabs = {

	selectors: {
        element: '[data-tabs]',
        wrapper: '[data-tabs-wrapper]',
        trigger: '[data-tabs-target]',
        target:  '[data-tabs-id]'
    },

    options: {
        fixedHeight: true,
    },

    states: {
        current: null,
        init: null
    },

    init: function(){
        var self = this;

        $( self.selectors.element ).each( function() {
            var $element = $( this ),
            $wrapper = $element.find( self.selectors.wrapper ),
            $triggers = $element.find( self.selectors.trigger ),
            $targets = $element.find( self.selectors.target );

            self.states.current = $targets.filter( '.active' ).attr( 'data-tabs-id' );
            self.states.init = self.states.current;

            self.refreshHeights( $targets, $wrapper );

            $( window ).on( 'resize', helpers.debounce( function() {
                self.refreshHeights( $targets, $wrapper );
            }, 200 ) );

            $triggers.on( 'click', function() {
                var $tabItem = $( this ),
                tabID = $tabItem.attr( 'data-tabs-target' ),
                $target = $targets.filter( '[data-tabs-id="' + tabID + '"]' );

                if ( $target.length > 0 ) {
                    $triggers.removeClass( 'active' );
                    $targets.removeClass( 'active' );

                    $tabItem.addClass( 'active' );
                    $target.addClass( 'active' );

                    if ( self.options.fixedHeight === false ) {
                        $wrapper.css( 'height', $target.data( 'height' ) );
                    }

                    self.states.current = tabID;
                    $element.trigger( 'change' );
                }
            } );
        } );
    },

    refreshHeights: function( $targets, $wrapper ) {
        var self = this,
        maxHeight = 0;

        $targets.each( function() {
            var $target = $( this ),
            height = parseInt(  $target.outerHeight() );

            $target.data( 'height', height );
            maxHeight = maxHeight < height ? height : maxHeight;
        } );

        if ( self.options.fixedHeight === true ) {
            $wrapper.css( 'height', maxHeight );
        }
    }

}

export { tabs };
